var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useStore } from "@context/store";
import { Button } from "@components/ui";
import { useCallback } from "react";
import { DeliveryType } from "@schema/types";
var HavingTroubles = function () {
    var _a = useStore(), type = _a.type, setDeliveryType = _a.setDeliveryType, availableDeliveryTypes = _a.availableDeliveryTypes;
    var handleTryPickup = function () {
        setDeliveryType(DeliveryType.Pickup);
    };
    var handleTryDoorstep = function () {
        setDeliveryType(DeliveryType.Doorstep);
    };
    var _availableDeliveryTypes = useCallback(function () {
        return availableDeliveryTypes.map(function (_a) {
            var type = _a.type;
            return type;
        });
    }, [availableDeliveryTypes]);
    var buttonClasses = "float-left mr-2 mb-2";
    return (_jsxs(_Fragment, { children: [_jsx("hr", { className: "border-t clear-both" }, void 0),
            _jsx("p", __assign({ className: "text-decent text-sm" }, { children: "Having troubles?" }), void 0),
            type === DeliveryType.Pickup &&
                _availableDeliveryTypes().includes(DeliveryType.Doorstep) && (_jsx(_Fragment, { children: _jsx(Button, __assign({ className: buttonClasses, onClick: handleTryDoorstep }, { children: "Try with doorstep delivery" }), void 0) }, void 0)),
            type === DeliveryType.Doorstep &&
                _availableDeliveryTypes().includes(DeliveryType.Pickup) && (_jsx(_Fragment, { children: _jsx(Button, __assign({ className: buttonClasses, onClick: handleTryPickup }, { children: "Try to find a pickup" }), void 0) }, void 0))] }, void 0));
};
export default HavingTroubles;
